import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Autocomplete from 'react-autocomplete';
import axios from 'axios';
import API from '../../API';
import './location-modal.css';

class LocationModal extends Component {
  constructor(props) {
    super(props);
    this.INITIAL_ERROR_STATE = {
      type_of_addressError: '',
      street_nameError: "",
      cityError: "",
      stateError: "",
      zip_codeError: "",
    };

    this.state = {
      type_of_address: '',
      street_name: '',
      address_line1: '',
      address_line2: '',
      city: '',
      state: '',
      zip_code: '',
      errors: this.INITIAL_ERROR_STATE,
      loadingShow: false,
      stateSuggestions: [],
      citySuggestions: [],
      stateName: "",
      selected_state: "",
      cityName: "",
      city_selected: "",
      selectedStateId: "",
    };

    this.stateSelectHandler = this.stateSelectHandler.bind(this);
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [`${name}Error`]: ""
      }
    }));
  };


  handleSubmit = event => {
    event.preventDefault();

    let errors = { ...this.INITIAL_ERROR_STATE };
    this.setState({ errors });

    const isValid = this.validate_form();
    if (isValid) {
      const data = JSON.stringify({
        address: {
          type_of_address: this.state.type_of_address,
          street_name: this.state.street_name,
          address_line1: this.state.address_line1,
          address_line2: this.state.address_line2,
          city: this.state.city,
          state: this.state.state,
          zip_code: this.state.zip_code
        }
      });

      this.setState({ loadingShow: true });

      axios.post(API.baseURL + `/create_address.json`, data, API.options)
        .then((result) => {
          this.setState({ loadingShow: false });
          localStorage.setItem("default_location", this.state.city + ', ' + this.state.state);

          if (result.status === 201) {
            if (this.props.onSave) {
              this.props.onSave();
            }
          }
        })
        .catch(error => {
          console.error("Error creating address:", error);
          this.setState({ loadingShow: false });
        });
    }
  }

  validate_form = () => {
    let errors = { ...this.INITIAL_ERROR_STATE };
    let isValid = true;

    if (this.state.type_of_address.trim() === '') {
      errors.type_of_addressError = "Enter an address";
      isValid = false;
    }

    if (this.state.street_name.trim() === '') {
      errors.street_nameError = "Enter a street name";
      isValid = false;
    }

    if (this.state.state.trim() === '') {
      errors.stateError = "Enter a state";
      isValid = false;
    }

    if (this.state.city.trim() === '') {
      errors.cityError = "Enter a city";
      isValid = false;
    }

    if (this.state.zip_code.trim() === '' || isNaN(this.state.zip_code.trim())) {
      errors.zip_codeError = "Enter a valid zipcode";
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  }

  onSuggestionsStateFetchRequested = async (value) => {
    this.setState({
      stateName: value,
      errors: { ...this.state.errors, stateError: "" }
    });

    if (value.trim() === '')
      return;

    try {
      const response = await axios
        .get(API.baseURL + `/get_states?search=${value}`, API.options)
        .then(response => response.data);

      this.setState({
        stateSuggestions: response.data.state,
        selected_state: ""
      });
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  onSuggestionsCityFetchRequested = async (value) => {
    this.setState({
      cityName: value,
      errors: { ...this.state.errors, cityError: "" }
    });

    if (value.trim() === '')
      return;

    try {
      const response = await axios
        .get(API.baseURL + `/get_cities?search=${value}&state_id=${this.state.selectedStateId}`, API.options)
        .then(response => response.data);

      this.setState({
        citySuggestions: response.data.city,
        city_selected: ""
      });
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  stateSelectHandler(state, item) {
    this.setState({
      stateName: item.name,
      selected_state: item.name,
      selectedStateId: item.id,
      state: item.name,
      address_line1: "",
      city: "",
      city_selected: "",
      citySuggestions: [],
      stateSuggestions: []
    });
  }

  validateStateSelection = () => {
    setTimeout(() => {
      const { stateName, stateSuggestions, state } = this.state;

      if (state) {
        this.setState({ stateName: state});
        return;
      }

      // Check if typed state matches any suggestion
      const matchedState = stateSuggestions.find(
          (item) => item.name.toLowerCase() === stateName.toLowerCase()
      );

      if (!matchedState) {
        this.setState({
          stateName: '',
          selected_state: '',
          selectedStateId: '',
          state: '',
          address_line1: '',
          city: '',
          city_selected: '',
        });
      } else {
        this.stateSelectHandler(matchedState, matchedState)
      }
    }, 100);
  };

  onCitySelectHandler = (city, item) => {
    this.setState({
      address_line1: item.name + ", " + item.state,
      city: item.name,
      cityName: item.name,
      city_selected: item.name,
      citySuggestions: [],
    });
  }

  validateCitySelection = () => {
    setTimeout(() => {
      const { cityName, citySuggestions, city } = this.state;
      console.log(this.state)

      if (city) {
        this.setState({ cityName: city});
        return;
      }

      const matchedCity = citySuggestions.find(
          (item) => item.name.toLowerCase() === cityName.toLowerCase()
      );

      if (!matchedCity) {
        this.setState({
          address_line1: '',
          cityName: '',
          city_selected: '',
          city: ''
        });
      } else {
        this.onCitySelectHandler(matchedCity, matchedCity)
    }
    }, 100);
  };

  capitalize = (str) => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
  }

  render() {
    const { errors, loadingShow } = this.state;

    return (
      <Modal 
        isOpen={this.props.show} 
        toggle={this.props.onClose}
        className="location-modal"
      >
        <div className="modal-header">
          <h5 className="modal-title">Add Location</h5>
          <button type="button" className="close" onClick={this.props.onClose}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        
        <div className="modal-body">
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="type_of_address"
                className="form-control custom-class ebw-form__input position-relative pl-3"
                style={{ height: 52 }}
                placeholder="ex: Home/Office"
                value={this.state.type_of_address}
                onChange={this.handleChange}
              />
              {errors.type_of_addressError && 
                <div className="ebw-error">{errors.type_of_addressError}</div>
              }
            </div>

            <div className="form-group">
              <input
                type="text"
                name="street_name"
                className="form-control custom-class ebw-form__input position-relative pl-3"
                style={{ height: 52 }}
                placeholder="Full Address"
                value={this.state.street_name}
                onChange={this.handleChange}
              />
              {errors.street_nameError && 
                <div className="ebw-error">{errors.street_nameError}</div>
              }
            </div>

            <div className="form-group">
              <Autocomplete
                getItemValue={(item) => item.name}
                items={this.state.stateSuggestions}
                renderItem={(item, isHighlighted) =>
                  <div 
                    key={item.id} 
                    style={{ 
                      background: isHighlighted ? '#f5f5f5' : 'white', 
                      padding: "10px", 
                      textTransform: 'capitalize' 
                    }}
                  >
                    {this.capitalize(item.name) + " (" + item.abbreviation + ")"}
                  </div>
                }
                renderMenu={(items, value) => (
                    <div
                        style={{
                          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                          background: '#fff',
                          padding: '2px 0',
                          borderRadius: '4px',
                          overflow: 'auto',
                          maxHeight: '200px',
                          width: '100%',
                          zIndex: '9'
                        }}
                    >
                      {value.trim() === "" ? (
                          <div style={{ padding: '10px', color: '#888' }}>Type to search</div>
                      ) : items.length > 0 ? (
                          items
                      ) : (
                          <div style={{ padding: '10px', color: '#888' }}>No results found</div>
                      )}
                    </div>
                )}
                renderInput={(props) =>
                  <input
                    {...props}
                    className="form-control custom-class ebw-form__input position-relative pl-3"
                    style={{ height: 52 }}
                    placeholder="State"
                    // onBlur={(e) => {
                    //   props.onBlur?.(e);
                    //   this.validateStateSelection();
                    // }}
                  />
                }
                wrapperStyle={{
                  position: 'relative',
                  width: '100%'
                }}
                value={this.state.stateName}
                onChange={e => this.onSuggestionsStateFetchRequested(e.target.value)}
                onSelect={this.stateSelectHandler}
              />
              {errors.stateError && 
                <div className="ebw-error">{errors.stateError}</div>
              }
            </div>

            <div className="form-group">
              <Autocomplete
                getItemValue={(item) => item.name}
                items={this.state?.citySuggestions??[]}
                renderItem={(item, isHighlighted) =>
                  <div 
                    key={item.id} 
                    style={{ 
                      background: isHighlighted ? '#f5f5f5' : 'white', 
                      padding: "10px", 
                      textTransform: 'capitalize' 
                    }}
                  >
                    {this.capitalize(item.name)}
                  </div>
                }
                renderMenu={(items, value) => (
                    <div
                        style={{
                          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                          background: '#fff',
                          padding: '2px 0',
                          borderRadius: '4px',
                          overflow: 'auto',
                          maxHeight: '200px',
                          width: '100%',
                          zIndex: '9'
                        }}
                    >
                      {value.trim() === "" ? (
                          <div style={{ padding: '10px', color: '#888' }}>Type to search</div>
                      ) : items.length > 0 ? (
                          items
                      ) : (
                          <div style={{ padding: '10px', color: '#888' }}>No results found</div>
                      )}
                    </div>
                )}
                renderInput={(props) =>
                  <input
                    {...props}
                    className="form-control custom-class ebw-form__input position-relative pl-3"
                    style={{ height: 52 }}
                    placeholder="City"
                    // onBlur={(e) => {
                    //   props.onBlur?.(e);
                    //   this.validateCitySelection();
                    // }}
                  />
                }
                wrapperStyle={{
                  position: 'relative',
                  width: '100%'
                }}
                value={this.state.cityName}
                onChange={e => this.onSuggestionsCityFetchRequested(e.target.value)}
                onSelect={this.onCitySelectHandler}
              />
              {errors.cityError && 
                <div className="ebw-error">{errors.cityError}</div>
              }
            </div>

            <div className="form-group">
              <input
                type="text"
                name="zip_code"
                className="form-control custom-class ebw-form__input position-relative pl-3"
                style={{ height: 52 }}
                placeholder="Zip Code"
                value={this.state.zip_code}
                onChange={this.handleChange}
              />
              {errors.zip_codeError && 
                <div className="ebw-error">{errors.zip_codeError}</div>
              }
            </div>

            <div className="privacy-note text-center mt-3 mb-3">
              Your address won't be shared with provider/providers until you hire someone.
            </div>

            <button
              type="submit"
              className="btn btn-primary ebw-btn ebw-btn-primary mx-auto d-block"
              style={{ height: 52, width: 'auto', minWidth: '120px' }}
              disabled={loadingShow}
            >
              {loadingShow ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      </Modal>
    );
  }
}

export default LocationModal; 